import { Box, Container, styled, Typography } from "@mui/material";
import React from "react";
import collectionBaner from "../assets/images/collection/collection-baner.jpg";
import img_col1 from "../assets/images/collection/pinmap-9_540x.webp";
import img_col2 from "../assets/images/collection/pinmap-10_540x.webp";
import img_col3 from "../assets/images/collection/pinmap-11_540x.webp";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import loading from "../assets/svg/imgLoading.svg";
import { Helmet } from "react-helmet";

export const Section = styled((props) => (
  <Box {...props}>{props.children}</Box>
))(({ theme, img }) => ({
  height: "125px",
  width: "100%",
  background: `url(${img})`,
  position: "relative",
  backgroundSize: "cover",
  backgroundPosition: "center center",
  "&::after": {
    content: "''",
    height: "100%",
    width: "100%",
    position: "absolute",
    background: "black",
    opacity: 0.5,
  },
}));
// const SectionImageTitle = ({url,title})=>{

// }

const Collection = () => {
  const navigate = useNavigate();
  const collects = [
    {
      title: "men's clothing",
      imgSrc: img_col2,
      counts: "18",
      link: "men's clothing",
    },
    {
      title: "women's clothing",
      imgSrc: img_col1,
      counts: "12",
      link: "women's clothing",
    },
    { title: "jewelery", imgSrc: img_col3, counts: "18", link: "jewelery" },
  ];
  return (
    <Box>
      <Helmet title={"collections"} />
      <Section img={collectionBaner}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat,sans-serif",
            fontWeight: 600,
            color: "white",
            zIndex: 10,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          collections
        </Typography>
      </Section>
      <Container sx={{ height: "auto" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            width: "100%",
            height: "100%",
            py: { xs: 3, sm: 6, md: 8, lg: 10 },
            gap: 2,
            justifyContent: "center",
          }}
        >
          {collects.map((collect, index) => {
            return (
              <Box
                key={index}
                sx={{
                  height: "100%",
                  width: {
                    xs: "calc(50% - 16px)",
                    sm: "calc(50% - 16px)",
                    md: "calc(33.33% - 16px)",
                    lg: "calc(33.33% - 16px)",
                  },
                }}
              >
                <Box
                  sx={{ height: "100%", width: "100%", cursor: "pointer" }}
                  onClick={() => navigate(collect.link)}
                >
                  <LazyLoadImage
                    placeholderSrc={loading}
                    src={collect.imgSrc}
                    alt={collect.title}
                    width="100%"
                    height="100%"
                    style={{ objectFit: "cover", objectPosition: "top center" }}
                  />
                </Box>
                <Box sx={{ p: 1 }}>
                  <Typography
                    variant="h6"
                    align="center"
                    sx={{ fontFamily: "lato,sans-serif", letterSpacing: "2px" }}
                  >
                    {collect.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    align="center"
                    sx={{ fontFamily: "lato,sans-serif", color: "#A4A09C" }}
                  >
                    {collect.counts}{" "}
                    {collect.counts === 1 ? "product" : "products"}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
  // height:{xs:'200px',sm:'300px',md:'400px',lg:'450px'}
  // aspectRatio:{xs:,sm:,md:2/3}
};

export default Collection;
